export default () => ({
  list: [],
  documentTemplate: {},
})
